import { post } from './api';
import { CHIRP_APP_URL, COGNITO_CLIENT_ID, COGNITO_URL } from 'config';
import { GetUserAuthTokensResponseDTO } from 'declarations/dto/auth';
import { utf8ToBase64 } from 'helpers/string';

export const getTokensByAuthorizationCodeApi = async (grantCode: string) => {
  const data = new URLSearchParams({
    Authorization: `Basic ${utf8ToBase64(COGNITO_CLIENT_ID as string)}`,
    grant_type: 'authorization_code',
    client_id: COGNITO_CLIENT_ID as string,
    code: grantCode,
    redirect_uri: `${CHIRP_APP_URL}/login`,
  });

  const response = await post<GetUserAuthTokensResponseDTO>(`/oauth2/token`, data, {
    baseURL: `${COGNITO_URL}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return response.data;
};

export const getTokensByRefreshTokenApi = async (refreshToken: string) => {
  const data = new URLSearchParams({
    Authorization: `Basic ${utf8ToBase64(COGNITO_CLIENT_ID as string)}`,
    grant_type: 'refresh_token',
    client_id: COGNITO_CLIENT_ID as string,
    refresh_token: refreshToken,
  });

  const response = await post<GetUserAuthTokensResponseDTO>(`/oauth2/token`, data, {
    baseURL: `${COGNITO_URL}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return response.data;
};
